import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { LocationDTO } from '../../../model/LocationDTO';

@Block() @Component
export class ApartmentsOverviewHeadingBlock extends BaseBlock {
	@Prop() location: LocationDTO;

	get city() {
		var result = this.location.city;
		if (this.location.cityPart) {
			result += " - " + this.location.cityPart;
		}

		return result;
	}

	get locationCatalogNo(): string {
		var retVal = this.location.catalogNumber;
		if (this.location.catalogMarketingNumber && this.location.catalogMarketingNumber != "") {
			retVal = this.location.catalogMarketingNumber;
		}

		return retVal;
	}

	get showBreadcrumbs() {
		return !(this.$route.query.predbezne && this.$route.query.csh);
	}
}

export default ApartmentsOverviewHeadingBlock;
